import { render, staticRenderFns } from "./CapacityForm.vue?vue&type=template&id=32e4bc56&scoped=true"
import script from "./CapacityForm.vue?vue&type=script&lang=js"
export * from "./CapacityForm.vue?vue&type=script&lang=js"
import style0 from "@/utils/rich_text_editor.css?vue&type=style&index=0&id=32e4bc56&prod&scoped=true&lang=css&external"
import style1 from "./CapacityForm.vue?vue&type=style&index=1&id=32e4bc56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e4bc56",
  null
  
)

export default component.exports